import { TreeTable } from "primeng/primeng";
import { Input, Component } from "@angular/core";

@Component({
  selector: "p-ttToggler",
  templateUrl: "./treetabletoggler.component.html"
})
export class TreeTableTogglerComponent {
  @Input() rowNode: any;
  @Input() marginLeft = 2;
  @Input() color = "#000000";

  constructor(public tt: TreeTable) {}

  onClick(event: Event) {
    this.rowNode.node.expanded = !this.rowNode.node.expanded;

    if (this.rowNode.node.expanded) {
      this.tt.onNodeExpand.emit({
        originalEvent: event,
        node: this.rowNode.node
      });
    } else {
      this.tt.onNodeCollapse.emit({
        originalEvent: event,
        node: this.rowNode.node
      });
    }

    this.tt.updateSerializedValue();
    this.tt.tableService.onUIUpdate(this.tt.value);

    event.preventDefault();
  }
}
